import { InputProps } from '@chakra-ui/input';

const defaultProps: InputProps = {
  focusBorderColor: 'brand.500',
  variant: 'outline',
};

export const Select = {
  variants: {
    outline: {
      field: {
        borderColor: 'brand.700',
        backgroundColor: 'brand.1300',
        borderRadius: '4px',

        fontSize: '0.875rem',
        _hover: {
          borderColor: 'brand.1100',
        },
        _placeholder: {
          color: 'brand.600',
        },
      },
    },
  },
  defaultProps,
};
